import NotificationPage from "@/features/system-settings/pages/Notification";

const Notification = () => {
  return <NotificationPage />;
};

export default Notification;
